import { Component, inject } from '@angular/core'
import * as FileSaver from 'file-saver'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'
import { ReporteService } from 'src/app/core/modules/reportes/services/reporte.service'
import { SpinnerService } from 'src/app/core/services/spinner.service'
import { MessageUtil } from 'src/app/core/utils/message.util'

@Component({
  selector: 'app-visor-reporte',
  templateUrl: './visor-reporte.component.html',
  standalone: false,
  styleUrls: ['./visor-reporte.component.css'],
})
export class VisorReporteComponent {
  private _reporteService = inject(ReporteService)
  private _spinnerService = inject(SpinnerService)
  modalRef = inject(DynamicDialogRef)
  modalConfig = inject(DynamicDialogConfig)

  public parametros: any
  public pdfGenerado: any
  public mostrarOpcionesDescarga: boolean = false
  public nombreArchivo: string = 'document'

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[])

  constructor() {}

  ngOnInit(): void {
    this.nombreArchivo = this.modalConfig.data.nombreArchivo || 'document'
    this.parametros = this.modalConfig.data.parametros
    /*
      {
        "reportName": "FinanceCalculator",
        "parameters": {
          "ClientNameParameter": "Yesid Salazar",
          "AmountParameter": "10000000"
      }
    */

    this._reporteService.generar(this.parametros).subscribe({
      next: (pdf) => {
        if (pdf.type === 'application/octet-stream') {
          this.pdfGenerado = pdf
          this.mostrarOpcionesDescarga = true
        }
      },
      error: (e) => {
        this._spinnerService.hide()
        MessageUtil.showError()
      },
      complete: () => {
        this._spinnerService.hide()
      },
    })
  }

  public descargar(formato: string): void {
    this._spinnerService.show()

    var parametrosFormato = this.parametros
    parametrosFormato.formato = formato

    this._reporteService.generar(this.parametros).subscribe({
      next: (pdf: any) => {
        let tipo = 'application/pdf'
        let extension = 'pdf'

        if (formato === 'EXCELOPENXML') {
          tipo = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          extension = 'xlsx'
        }

        var blob = new Blob([pdf], { type: tipo })
        FileSaver.saveAs(blob, `${this.nombreArchivo}.${extension}`)
      },
      error: (e) => {
        this._spinnerService.hide()
      },
      complete: () => {
        this._spinnerService.hide()
      },
    })
  }
}
